// src/api/getAllOccasion.js
import axios from "axios";
import { getOccasionsByEventId } from "../server/Api"; // adjust the import path

export const getAllOccasions = async (eventId) => {
  if (!eventId) return [];

  try {
    const url = getOccasionsByEventId(eventId);
    const res = await axios.get(url);
    // Filter only active occasions
    const activeOccasions = (res.data.data || []).filter(
      (occasion) => occasion.isOccasionActive
    );
    return activeOccasions;
  } catch (error) {
    // Empty event (legacy 404) is not a failure — treat as no occasions
    if (error.response?.status === 404) {
      return [];
    }
    console.error("Failed to fetch occasions", error);
    throw error;
  }
};
